import { allCommodities } from 'helpers/fakeData';

import { PredictionMarket, ProbabilityDataPoint } from './types';

const cocoa = allCommodities[0];
const cassava = allCommodities[1];
const cashew = allCommodities[2];
const sorghum = allCommodities[3];
const maize = allCommodities[4];
const rice = allCommodities[7];

function makeCommodityFields(c: (typeof allCommodities)[number]) {
  return {
    commodityId: c.id,
    commodityName: c.name,
    commodityImage: c.image,
    commodityTicker: c.ticker,
  };
}

export const allPredictionMarkets: PredictionMarket[] = [
  // --- Weekly: Hit Price ---
  {
    id: 'w-hp-1',
    ...makeCommodityFields(cocoa),
    question: 'What price will Cocoa hit Feb 24 - Mar 2?',
    questionType: 'weekly-hit-price',
    timeCategory: 'weekly',
    weeklySubCategory: 'hit-price',
    totalVolume: 245_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'w-hp-1-1', label: '↑ 1,200', probability: 12, volume: 80_000, yesPrice: 0.12, noPrice: 0.88 },
      { id: 'w-hp-1-2', label: '↑ 1,100', probability: 25, volume: 65_000, yesPrice: 0.25, noPrice: 0.75 },
      { id: 'w-hp-1-3', label: '↑ 1,050', probability: 40, volume: 55_000, yesPrice: 0.4, noPrice: 0.6 },
      { id: 'w-hp-1-4', label: '↑ 1,000', probability: 58, volume: 45_000, yesPrice: 0.58, noPrice: 0.42 },
    ],
  },
  {
    id: 'w-hp-2',
    ...makeCommodityFields(maize),
    question: 'What price will Maize hit Feb 24 - Mar 2?',
    questionType: 'weekly-hit-price',
    timeCategory: 'weekly',
    weeklySubCategory: 'hit-price',
    totalVolume: 120_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'w-hp-2-1', label: '↑ 5,500', probability: 8, volume: 40_000, yesPrice: 0.08, noPrice: 0.92 },
      { id: 'w-hp-2-2', label: '↑ 5,200', probability: 18, volume: 35_000, yesPrice: 0.18, noPrice: 0.82 },
      { id: 'w-hp-2-3', label: '↑ 5,000', probability: 45, volume: 45_000, yesPrice: 0.45, noPrice: 0.55 },
    ],
  },

  // --- Weekly: Above/Below ---
  {
    id: 'w-ab-1',
    ...makeCommodityFields(cocoa),
    question: 'Cocoa above GHS1,100 on Mar 2?',
    questionType: 'weekly-above-below',
    timeCategory: 'weekly',
    weeklySubCategory: 'above-below',
    totalVolume: 180_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'w-ab-1-1', label: '1,100', probability: 65, volume: 100_000, yesPrice: 0.65, noPrice: 0.35 },
      { id: 'w-ab-1-2', label: '1,050', probability: 78, volume: 80_000, yesPrice: 0.78, noPrice: 0.22 },
    ],
  },
  {
    id: 'w-ab-2',
    ...makeCommodityFields(rice),
    question: 'Rice above GHS8,500 on Mar 2?',
    questionType: 'weekly-above-below',
    timeCategory: 'weekly',
    weeklySubCategory: 'above-below',
    totalVolume: 95_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: false,
    outcomes: [
      { id: 'w-ab-2-1', label: '8,500', probability: 30, volume: 50_000, yesPrice: 0.3, noPrice: 0.7 },
      { id: 'w-ab-2-2', label: '8,000', probability: 55, volume: 45_000, yesPrice: 0.55, noPrice: 0.45 },
    ],
  },

  // --- Weekly: Price Range ---
  {
    id: 'w-pr-1',
    ...makeCommodityFields(cocoa),
    question: 'Cocoa price on Mar 2?',
    questionType: 'weekly-price-range',
    timeCategory: 'weekly',
    weeklySubCategory: 'price-range',
    totalVolume: 310_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'w-pr-1-1', label: '<900', probability: 5, volume: 25_000, yesPrice: 0.05, noPrice: 0.95 },
      { id: 'w-pr-1-2', label: '900-1,000', probability: 15, volume: 55_000, yesPrice: 0.15, noPrice: 0.85 },
      { id: 'w-pr-1-3', label: '1,000-1,100', probability: 45, volume: 120_000, yesPrice: 0.45, noPrice: 0.55 },
      { id: 'w-pr-1-4', label: '1,100-1,200', probability: 28, volume: 80_000, yesPrice: 0.28, noPrice: 0.72 },
      { id: 'w-pr-1-5', label: '>1,200', probability: 7, volume: 30_000, yesPrice: 0.07, noPrice: 0.93 },
    ],
  },
  {
    id: 'w-pr-2',
    ...makeCommodityFields(cassava),
    question: 'Cassava price on Mar 2?',
    questionType: 'weekly-price-range',
    timeCategory: 'weekly',
    weeklySubCategory: 'price-range',
    totalVolume: 150_000,
    endDate: '2026-03-02T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'w-pr-2-1', label: '<1,800', probability: 10, volume: 20_000, yesPrice: 0.1, noPrice: 0.9 },
      { id: 'w-pr-2-2', label: '1,800-2,000', probability: 35, volume: 50_000, yesPrice: 0.35, noPrice: 0.65 },
      { id: 'w-pr-2-3', label: '2,000-2,200', probability: 40, volume: 55_000, yesPrice: 0.4, noPrice: 0.6 },
      { id: 'w-pr-2-4', label: '>2,200', probability: 15, volume: 25_000, yesPrice: 0.15, noPrice: 0.85 },
    ],
  },

  // --- Monthly ---
  {
    id: 'm-1',
    ...makeCommodityFields(cocoa),
    question: 'What price will Cocoa hit in March?',
    questionType: 'monthly-hit-price',
    timeCategory: 'monthly',
    totalVolume: 520_000,
    endDate: '2026-03-31T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'm-1-1', label: '↑ 1,500', probability: 5, volume: 80_000, yesPrice: 0.05, noPrice: 0.95 },
      { id: 'm-1-2', label: '↑ 1,300', probability: 15, volume: 120_000, yesPrice: 0.15, noPrice: 0.85 },
      { id: 'm-1-3', label: '↑ 1,200', probability: 30, volume: 160_000, yesPrice: 0.3, noPrice: 0.7 },
      { id: 'm-1-4', label: '↑ 1,100', probability: 55, volume: 160_000, yesPrice: 0.55, noPrice: 0.45 },
    ],
  },
  {
    id: 'm-2',
    ...makeCommodityFields(cashew),
    question: 'What price will Cashew hit in March?',
    questionType: 'monthly-hit-price',
    timeCategory: 'monthly',
    totalVolume: 340_000,
    endDate: '2026-03-31T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'm-2-1', label: '↑ 3,500', probability: 10, volume: 90_000, yesPrice: 0.1, noPrice: 0.9 },
      { id: 'm-2-2', label: '↑ 3,200', probability: 28, volume: 120_000, yesPrice: 0.28, noPrice: 0.72 },
      { id: 'm-2-3', label: '↑ 3,000', probability: 50, volume: 130_000, yesPrice: 0.5, noPrice: 0.5 },
    ],
  },
  {
    id: 'm-3',
    ...makeCommodityFields(sorghum),
    question: 'What price will Sorghum hit in March?',
    questionType: 'monthly-hit-price',
    timeCategory: 'monthly',
    totalVolume: 210_000,
    endDate: '2026-03-31T23:59:59Z',
    isLive: false,
    outcomes: [
      { id: 'm-3-1', label: '↑ 4,500', probability: 8, volume: 50_000, yesPrice: 0.08, noPrice: 0.92 },
      { id: 'm-3-2', label: '↑ 4,200', probability: 22, volume: 80_000, yesPrice: 0.22, noPrice: 0.78 },
      { id: 'm-3-3', label: '↑ 4,000', probability: 48, volume: 80_000, yesPrice: 0.48, noPrice: 0.52 },
    ],
  },

  // --- Yearly ---
  {
    id: 'y-1',
    ...makeCommodityFields(cocoa),
    question: 'What price will Cocoa hit in 2026?',
    questionType: 'yearly-hit-price',
    timeCategory: 'yearly',
    totalVolume: 1_200_000,
    endDate: '2026-12-31T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'y-1-1', label: '↑ 2,000', probability: 10, volume: 200_000, yesPrice: 0.1, noPrice: 0.9 },
      { id: 'y-1-2', label: '↑ 1,500', probability: 35, volume: 400_000, yesPrice: 0.35, noPrice: 0.65 },
      { id: 'y-1-3', label: '↑ 1,200', probability: 60, volume: 600_000, yesPrice: 0.6, noPrice: 0.4 },
    ],
  },
  {
    id: 'y-2',
    ...makeCommodityFields(cocoa),
    question: "Cocoa's best month in 2026?",
    questionType: 'yearly-best-month',
    timeCategory: 'yearly',
    totalVolume: 800_000,
    endDate: '2026-12-31T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'y-2-1', label: 'January', probability: 5, volume: 50_000, yesPrice: 0.05, noPrice: 0.95 },
      { id: 'y-2-2', label: 'February', probability: 8, volume: 60_000, yesPrice: 0.08, noPrice: 0.92 },
      { id: 'y-2-3', label: 'March', probability: 15, volume: 100_000, yesPrice: 0.15, noPrice: 0.85 },
      { id: 'y-2-4', label: 'April', probability: 12, volume: 90_000, yesPrice: 0.12, noPrice: 0.88 },
      { id: 'y-2-5', label: 'May', probability: 10, volume: 80_000, yesPrice: 0.1, noPrice: 0.9 },
      { id: 'y-2-6', label: 'June', probability: 20, volume: 120_000, yesPrice: 0.2, noPrice: 0.8 },
    ],
  },
  {
    id: 'y-3',
    ...makeCommodityFields(maize),
    question: 'What price will Maize hit in 2026?',
    questionType: 'yearly-hit-price',
    timeCategory: 'yearly',
    totalVolume: 900_000,
    endDate: '2026-12-31T23:59:59Z',
    isLive: true,
    outcomes: [
      { id: 'y-3-1', label: '↑ 7,000', probability: 12, volume: 150_000, yesPrice: 0.12, noPrice: 0.88 },
      { id: 'y-3-2', label: '↑ 6,000', probability: 30, volume: 350_000, yesPrice: 0.3, noPrice: 0.7 },
      { id: 'y-3-3', label: '↑ 5,500', probability: 55, volume: 400_000, yesPrice: 0.55, noPrice: 0.45 },
    ],
  },
];

function generateProbabilityTimeSeries(
  outcomeIds: string[],
  baseProbabilities: number[],
  days: number,
): ProbabilityDataPoint[] {
  const points: ProbabilityDataPoint[] = [];
  const now = new Date();
  for (let i = days; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    const dateStr = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const values: Record<string, number> = {};
    outcomeIds.forEach((id, idx) => {
      const base = baseProbabilities[idx];
      const jitter = (Math.random() - 0.5) * 10;
      values[id] = Math.max(0.5, Math.min(99, base + jitter + (days - i) * 0.1));
    });
    points.push({ timestamp: dateStr, label: dateStr, values });
  }
  return points;
}

export function getProbabilityHistory(market: PredictionMarket): ProbabilityDataPoint[] {
  const ids = market.outcomes.map((o) => o.id);
  const probs = market.outcomes.map((o) => o.probability);
  return generateProbabilityTimeSeries(ids, probs, 14);
}

export function getMarketCountByCategory(
  category: 'all' | 'weekly' | 'monthly' | 'yearly',
): number {
  if (category === 'all') return allPredictionMarkets.length;
  return allPredictionMarkets.filter((m) => m.timeCategory === category).length;
}

export function formatVolume(volume: number): string {
  if (volume >= 1_000_000) return `GHS${(volume / 1_000_000).toFixed(1)}M`;
  if (volume >= 1_000) return `GHS${(volume / 1_000).toFixed(0)}K`;
  return `GHS${volume}`;
}

export function formatPrice(price: number): string {
  if (price < 0.01) return '0.0¢';
  return `${(price * 100).toFixed(1)}¢`;
}
